import type { ReactNode } from 'react';
import './EmptyState.css';

export interface EmptyStateProps {
  /** One sentence in plain words: what this is and what happens next. It teaches. */
  title: string;
  description?: ReactNode;
  /** The one action that moves the user forward. */
  action?: ReactNode;
  /** Optional illustration (inline SVG component, under 30 KB); never an <img> of text. */
  illustration?: ReactNode;
  compact?: boolean;
}

export function EmptyState({
  title,
  description,
  action,
  illustration,
  compact,
}: EmptyStateProps): ReactNode {
  return (
    <div className={['pui-empty', compact && 'pui-empty--compact'].filter(Boolean).join(' ')}>
      {illustration ? (
        <div className="pui-empty__art" aria-hidden="true">
          {illustration}
        </div>
      ) : null}
      <h3 className="pui-empty__title">{title}</h3>
      {description ? <p className="pui-empty__desc">{description}</p> : null}
      {action ? <div className="pui-empty__action">{action}</div> : null}
    </div>
  );
}
